import { Denounce } from './../../../core/models/denounce.model';
import { createAction, props } from '@ngrx/store';

export const loadComplaints = createAction('[Dashboard] Load Complaints');

export const loadComplaintsSuccess = createAction(
	'[API] Get Complaints Success',
	props<{ complaints: Denounce[] }>()
);

export const loadComplaintsFailure = createAction(
	'[API] Get Complaints Failure',
	props<{ error: any }>()
);

export const addNewComplaint = createAction(
	'[Dashboard] Add New Complaint',
	props<{ complaint: Denounce }>()
);

export const addNewComplaintSuccess = createAction(
	'[Dashboard] Add New Complaint Success',
	props<{ complaint: Denounce }>()
);

export const addNewComplaintFail = createAction(
	'[Dashboard] Add New Complaint Fail',
	props<{ complaint: Denounce }>()
);

export const loadComplaintsPerPeriod = createAction(
	'[API] Get Complaints per Period'
);

export const loadComplaintsPerPeriodSuccess = createAction(
	'[API] Get Complaints per Period Success',
	props<{ complaints: any }>()
);

export const loadComplaintsPerPeriodFailure = createAction(
	'[API] Get Complaints per Period Failure'
);

export const loadPartialComplaintsPerPeriod = createAction(
	'[API] Get Partial Complaints per Period',
	props<{ from: string }>()
);

export const loadPartialComplaintsPerPeriodSuccess = createAction(
	'[API] Get Partial Complaints per Period Success',
	props<{ complaints: Denounce[] }>()
);

export const loadPartialComplaintsPerPeriodFailure = createAction(
	'[API] Get Partial Complaints per Period Failure'
);

export const loadpartialComplaintsPerPeriodEmpty = createAction(
	'[API] Get Partial Complaints per Period Empty'
);

export const loadBusLines = createAction('[API] Get Bus Lines');

export const loadBusLinesSuccess = createAction(
	'[API] Get Bus Lines Success',
	props<{ busLines: any }>()
);

export const loadBusLinesFailure = createAction('[API] Get Bus Lines Failure');

export const connectSse = createAction('[WS] Connect SSE');

export const connectSseSuccess = createAction(
	'[WS] Connect SSE Success',
	props<{ sse: EventSource }>()
);

export const connectSseFailure = createAction('[WS] Connect SSE Failure');
